/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import NotificationBanner from "../../components/Notifications/NotificationBanner";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import Tabs from "../Profile/TabComponent/Tabs";
import ContextConstructor from "../../components/Context/Context";
import sendLogError from "../../sendLogError";
/* MODULE IMPORTS */
import React, { Component } from "react";

/* CSS IMPORT */
import "./Profile.css";
import loadingImg from "../../images/loading.svg";

var reactPlugin = new ReactPlugin();

class Profile extends Component {
    static displayName = Profile.name;

    constructor(props) {
        super(props);
        this.state = {
            profile: [],
            error: [],
            loading: true,
        };
    }

    componentDidMount() {
        this.populateProfileData();
    }

    static errorLoadingPortfolio() {
        return (
            <div>
                <ErrorPage />
            </div>
        );
    }

    static renderProfileData(profile) {
        return (
            <div className="main">
                <NotificationBanner page="profile" />
                {/*descomentar para mostrar dados familiares, tema relacionado com RL <div className="Title">Dados pessoais e familiares</div>*/}
                <div className="Title">Dados pessoais</div>
                <div className="User-Fields">
                    <Tabs profile={profile} />
                </div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? (
            <div className="main-page-loading">
                <div className="loading">
                    <img src={loadingImg} alt="carregamento"></img>
                </div>
            </div>
        ) : this.state.error ? (
            Profile.errorLoadingPortfolio()
        ) : (
            Profile.renderProfileData(this.state.profile)
        );

        return <div>{contents}</div>;
    }

    async populateProfileData() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch("/Profile/GetProfile", { headers });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();

            this.setState({
                error: false,
                profile: data,
                loading: false,
            });

        } catch (error) {
            console.error("Error fetching profile:", error);

            this.setState({
                error: true,
                loading: false,
            });

            sendLogError(error.message, "populateProfileData");
        }
    }
}

Profile.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Profile);
